import { Fragment, memo, useCallback, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { findRoutePath } from "e3-common/utils/menuUtil";
import styles from "./E3MessageBox.module.css";
import { useBoundStore } from "e3-common/store/useBoundStore";
import useMessageBox from "e3-common/hooks/useMessageBox";
/**
 * 전역 Confirm, Alert, Prompt 메시지 박스
 * useMessageBox 훅을 이용해 제어
 */
const E3MessageBox = () => {
  const messageBoxRoot = document.getElementById("message-box");
  const inputRef = useRef(null);
  const { revealed, title, description, type, time } = useBoundStore((state) => state.messageBox);
  const { onInteractionEnd } = useMessageBox();

  const timerRef = useRef();

  useEffect(() => {
    if (time) {
      timerRef.current = setTimeout(() => {
        clearTimeout(timerRef.current);
        onInteractionEnd(true);
      }, time);
    }

    return () => clearTimeout(timerRef.current);
  }, [time]);

  const handleConfirmClick = useCallback(() => {
    if (type === "prompt") {
      onInteractionEnd({ confirm: true, msg: inputRef.current?.value || "" });
      return;
    }

    onInteractionEnd(true);
  }, [inputRef.current, type, onInteractionEnd]);

  const handleCancelClick = useCallback(() => {
    if (type === "prompt") {
      onInteractionEnd({ confirm: false, msg: "" });
      return;
    }
    onInteractionEnd(false);
  }, [type, onInteractionEnd]);

  const MessageBoxComponent = memo(() => (
    <>
      <div className={styles.dialogBackdrop} onClick={handleCancelClick} />
      <dialog className={styles.dialog} open={revealed}>
        <h2 className={styles[type] || styles.dialogTitle}>{title}</h2>
        {description && (
          <p className={styles.dialogDescription}>
            {typeof description == "string"
              ? description.split("\\n").map((e, idx) => (
                  <Fragment key={idx}>
                    {e}
                    <br />
                  </Fragment>
                ))
              : description}
          </p>
        )}

        {type === "prompt" && (
          <form onSubmit={handleConfirmClick}>
            <input autoFocus type="text" className={styles.dialogInput} ref={inputRef} />
          </form>
        )}
        <div className={styles.dialogButtons}>
          <button
            type="button"
            className={`${styles.dialogButton} ${styles.dialogButtonConfirm}`}
            onClick={handleConfirmClick}
          >
            확인
          </button>
          {type !== "alert" && type !== "error" && (
            <button
              type="button"
              className={`${styles.dialogButton} ${styles.dialogButtonCancel}`}
              onClick={handleCancelClick}
            >
              취소
            </button>
          )}
        </div>
      </dialog>
    </>
  ));

  return createPortal(revealed ? <MessageBoxComponent /> : null, messageBoxRoot);
};

E3MessageBox.displayName = "E3MessageBox";
export default E3MessageBox;
